// extracted by mini-css-extract-plugin
export default {"graphPanel":"QfcBsoVjZ61GAtWgNrBL","stenosisGraph":"ctfNXGzH2ByTyvwEpRiv"};